/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAccountingCollectionLedgers } from 'app/entities/accounting-collection-ledger/accounting-collection-ledger.reducer';
import { TransactionCategory } from 'app/shared/model/enumerations/transaction-category.model';
import { createEntity, getEntity, reset, updateEntity } from './accounting-transaction-bill.reducer';

export const AccountingTransactionBillUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const accountingCollectionLedgers = useAppSelector(state => state.accountingCollectionLedger.entities);
  const accountingTransactionBillEntity = useAppSelector(state => state.accountingTransactionBill.entity);
  const loading = useAppSelector(state => state.accountingTransactionBill.loading);
  const updating = useAppSelector(state => state.accountingTransactionBill.updating);
  const updateSuccess = useAppSelector(state => state.accountingTransactionBill.updateSuccess);
  const transactionCategoryValues = Object.keys(TransactionCategory);

  const handleClose = () => {
    navigate(`/accounting-transaction-bill${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAccountingCollectionLedgers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...accountingTransactionBillEntity,
      ...values,
      collection: accountingCollectionLedgers.find(it => it.id.toString() === values.collection?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          billCategory: 'DB',
          ...accountingTransactionBillEntity,
          collection: accountingTransactionBillEntity?.collection?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.accountingTransactionBill.home.createOrEditLabel" data-cy="AccountingTransactionBillCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.home.createOrEditLabel">
              Create or edit a AccountingTransactionBill
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="accounting-transaction-bill-id"
                  label={translate('tinyMedicRestApp.accountingTransactionBill.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.billId')}
                id="accounting-transaction-bill-billId"
                name="billId"
                data-cy="billId"
                type="text"
              />
              <UncontrolledTooltip target="billIdLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.billId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.billCategory')}
                id="accounting-transaction-bill-billCategory"
                name="billCategory"
                data-cy="billCategory"
                type="select"
              >
                {transactionCategoryValues.map(transactionCategory => (
                  <option value={transactionCategory} key={transactionCategory}>
                    {translate(`tinyMedicRestApp.TransactionCategory.${transactionCategory}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="billCategoryLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.billCategory" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.paymentId')}
                id="accounting-transaction-bill-paymentId"
                name="paymentId"
                data-cy="paymentId"
                type="text"
              />
              <UncontrolledTooltip target="paymentIdLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.paymentId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.active')}
                id="accounting-transaction-bill-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.cursor')}
                id="accounting-transaction-bill-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.lastUpdated')}
                id="accounting-transaction-bill-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.microSec')}
                id="accounting-transaction-bill-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.timestampEntry')}
                id="accounting-transaction-bill-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransactionBill.accountingTransactionId')}
                id="accounting-transaction-bill-accountingTransactionId"
                name="accountingTransactionId"
                data-cy="accountingTransactionId"
                type="text"
              />
              <UncontrolledTooltip target="accountingTransactionIdLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransactionBill.help.accountingTransactionId" />
              </UncontrolledTooltip>
              <ValidatedField
                id="accounting-transaction-bill-collection"
                name="collection"
                data-cy="collection"
                label={translate('tinyMedicRestApp.accountingTransactionBill.collection')}
                type="select"
              >
                <option value="" key="0" />
                {accountingCollectionLedgers
                  ? accountingCollectionLedgers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/accounting-transaction-bill" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AccountingTransactionBillUpdate;
